module.exports = "/_next/static/images/a9735d36fee0c21bb5338bccbcc23c44-push-notification.svg";